/* eslint-disable import/prefer-default-export */
const translations = new Map<string, Map<string, string>>([
  [
    "en-US",
    new Map([
      ["Colour", "Color"],
      ["Favourite", "Favorite"],
      ["Uncategorised", "Uncategorized"],
      ["Grey", "Gray"],
    ]),
  ],
])

// Stub for translations. Static strings should be wrapped with this, so they can be translated when needed.
export const s: typeof String.raw = (template, ...substitutions): string => {
  // return String.raw(template, ...substitutions)
  const cTemplate = Array.from(template.raw).join("{{}}")
  const translationMap = translations.get(localStorage.getItem("lang") || "en-GB")
  const translated = (translationMap?.get(`${cTemplate}`) || cTemplate).split("{{}}")

  const concat = translated.reduce((acc, part, i) => {
    return acc + part + (substitutions[i] || "")
  }, "")

  return concat
}
